import ChartPDFParametersFormattingStrategy from '../../../reports/charts/pdfgenerator/formatters/ChartPDFParametersFormattingStrategy'
import messageResource from '../../../messageResource'
import UserNameFormat from '../../../util/UserNameFormat'
import ChartPDFDateRangeFormattingStrategy from '../../../pdf/formatters/ChartPDFDateRangeFormattingStrategy'
import ATReportParamsStringBuilder from '../../../reports/reportParamsStringBuilder/ATReportParamsStringBuilder'

export default class PDFParametersFormattingStrategy extends ChartPDFParametersFormattingStrategy {
    init(selectorsData, dateFormat, dateFormatForFile) {
        super.init(selectorsData, dateFormat, dateFormatForFile, ATReportsStore.getReportAuthorizationInfo(), ATReportParamsStringBuilder)
        return this;
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        return new ChartPDFDateRangeFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters) {
        const statusesFilter = ViewTTPageUtils.makeStatusFilterToDisplay(selectedParameters.statuses)
        return {
            firstRow: this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection),
            secondRow: _.isNull(statusesFilter) ? "" : this.parametersFormatter.formatStatusesSelection(statusesFilter)
        }
    }

    formatChartPDFFilterInformation(selectedParameters) {
        const statusesFilter = ViewTTPageUtils.makeStatusFilterToDisplay(selectedParameters.statuses)
        return {
            firstRow: this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection),
            secondRow: _.isNull(statusesFilter) ? "" : this.parametersFormatter.formatStatusesSelection(statusesFilter)
        }
    }

    formatChartPDFFileName(selectedParameters) {
        const fileNameParts = []
        const user = selectedParameters.user
        const formattedName = UserNameFormat.formatFML(user.firstName, user.lastName, user.middleName)
        fileNameParts.push(formattedName)
        fileNameParts.push(this.dateParametersFormattingStrategy.formatDateForFileName(selectedParameters.dateParameters))
        return messageResource.getMessage('view_tt.pdf.file_name', fileNameParts)/*.replace(/[^a-z0-9]/gi, '_').toLowerCase()*/
    }

    formatChartPDFHeaderTitle(selectedParameters) {
        const user = selectedParameters.user
        const formattedName = UserNameFormat.formatFML(user.firstName, user.lastName, user.middleName)
        return messageResource.getMessage('view_tt.pdf.header', [formattedName])
    }
}



// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdf/PDFParametersFormattingStrategy.js